import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Carousel from "./components/Carousel";
import FeatureCards from "./components/FeatureCards";
import CekResi from "./components/CekResi";
import HasilProduksi from "./components/HasilProduksi";
import AboutUs from "./components/AboutUs";
import SumberProduksi from "./components/SumberProduksi";
import UpdatePengiriman from "./components/UpdatePengiriman";
import Login from "./components/Login";
import LupaSandi from "./components/LupaSandi";
import PetaniDashboard from "./page/Petani/PetaniDashboard";
import RencanaTanam from "./page/Petani/PetaniRT";
import PetaniRTLD from "./page/Petani/PetaniRTLD";
import PetaniRP from "./page/Petani/PetaniRP";
import PetaniP from "./page/Petani/PetaniP";
import PetaniFP from "./page/Petani/PetaniFP";
import PetaniPLD from "./page/Petani/PetaniPLD";
import SawitP from "./page/Petani/SawitP";
import Kebun from "./page/Kebun/Kebun";
import SawitK from "./page/Kebun/SawitK";
import KebunP from "./page/Kebun/KebunP";
import KebunPRT from "./page/Kebun/KebunPRT";
import KebunPRTLD from "./page/Kebun/KebunPRTLD";
import KebunPRP from "./page/Kebun/KebunPRP";
import KebunPRPLD from "./page/Kebun/KebunPRPLD";
import KebunL from "./page/Kebun/KebunL";
import KebunLD from "./page/Kebun/kebunLD";
import KebunT from "./page/Kebun/KebunT";
import KebunLP from "./page/Kebun/KebunLP";
import KebunPabrik from "./page/Kebun/KebunPabrik";
import KebunDetailPabrik from "./page/Kebun/KebunPabrikLD";
import Logistik from "./page/Logistik/Logistik";
import LogistikRP from "./page/Logistik/LogistikRP";
import LogistikP from "./page/Logistik/LogistikP";
import LogistikPR from "./page/Logistik/LogistikPR";
import LogistikRPLD from "./page/Logistik/LogistikRPLD";
import Pabrik from "./page/Pabrik/Pabrik";
import PabrikT from "./page/Pabrik/PabrikT";
import PabrikH from "./page/Pabrik/PabrikH";
import PabrikLD from "./page/Pabrik/PabrikLD";
import PabrikHLD from "./page/Pabrik/PabrikHLD";
import SawitPa from "./page/Pabrik/SawitPa";
import Admin from "./page/Admin/Admin";
import AdminDS from "./page/Admin/AdminDS";
import AdminDetail from "./page/Admin/AdminDetail";
import UserProfile from "./page/UserProfile";
import LogAktivitas from "./page/Kebun/LogAktivitas";
import "./App.css";
import GlobalDataTable from "./components/GlobalDataTable";

const App = () => {
  return (
    <Router>
      <GlobalDataTable />
      <div id="Top">
        <Routes>
          {/* Halaman Utama */}
          <Route
            path="/"
            element={
              <>
                <Navbar />
                <Carousel />
                <FeatureCards />
                <CekResi />
                <HasilProduksi />
                <AboutUs />
                <SumberProduksi />
                <UpdatePengiriman />
                <footer>
                  <p>&copy; 2024 Telsa Super Apps</p>
                </footer>
              </>
            }
          />

          {/* Route untuk Login */}
          <Route path="/login" element={<Login />} />
          <Route path="/lupakatasandi" element={<LupaSandi />} />

          {/* Route profile */}
          <Route path="/profile" element={<UserProfile />} />

          {/* Route Petani */}
          <Route path="/petani" element={<PetaniDashboard />} />
          <Route path="/petanirt" element={<RencanaTanam />} />
          <Route path="/petanirt/detail/:id" element={<PetaniRTLD />} />
          <Route path="/petanirp" element={<PetaniRP />} />
          <Route path="/petanip" element={<PetaniP />} />
          <Route path="/petanifp" element={<PetaniFP />} />
          <Route path="/petanip/detail/:id" element={<PetaniPLD />} />
          <Route path="/sawitP" element={<SawitP />} />

          {/* Route Kebun */}
          <Route path="/kebun" element={<Kebun />} />
          <Route path="/sawitk" element={<SawitK />} />
          <Route path="/kebunp" element={<KebunP />} />
          <Route path="/kebunprt" element={<KebunPRT />} />
          <Route path="/kebunprt/detail/:id" element={<KebunPRTLD />} />
          <Route path="/kebunprp" element={<KebunPRP />} />
          <Route path="/kebunprp/detail/:id" element={<KebunPRPLD />} />
          <Route path="/kebunl" element={<KebunL />} />
          <Route path="/kebunld/:id" element={<KebunLD />} />
          <Route path="/kebunt" element={<KebunT />} />
          <Route path="/kebunL/pengajuan" element={<KebunLP />} />
          <Route path="/kebunpabrik" element={<KebunPabrik />} />
          <Route path="/kebunpabrik/detail/:id" element={<KebunDetailPabrik />} />
          <Route path="/logaktivitas" element={<LogAktivitas />} />

          {/* Route Logistik */}
          <Route path="/logistik" element={<Logistik />} />
          <Route path="/logistikp" element={<LogistikP />} />
          <Route path="/logistikpr" element={<LogistikPR />} />
          <Route path="/logistikrp" element={<LogistikRP />} />
          <Route path="/logistikrpld/:id" element={<LogistikRPLD />} />

          {/* Route Pabrik */}
          <Route path="/pabrik" element={<Pabrik />} />
          <Route path="/sawitpa" element={<SawitPa />} />
          <Route path="/pabrikt" element={<PabrikT />} />
          <Route path="/pabrikh" element={<PabrikH />} />
          <Route path="/pabrikld/detail/:id" element={<PabrikLD />} />
          <Route path="/pabrikhld/detail/:id" element={<PabrikHLD />} />

          {/* Route Admin */}
          <Route path="/admin" element={<Admin />} />
          <Route path="/admins" element={<AdminDS />} />
          <Route path="/admins/detail/:id" element={<AdminDetail />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
